import _logger from 'utils/logger';
import API from 'api';
import { toMoment } from 'utils/normalizers';
import { setContentTypesPadrones, setLadas, setMeses } from 'store/catalogos';
import {
  setCarousels,
  setINPC,
  setNoticias,
  setNoticiasHome,
  setTiposDeNoticias,
} from 'store/app';
import { ID_ENTIDAD, DEV } from 'utils/env';
import { formatReceived } from 'utils/formatters';
import toSlug from 'utils/toSlug';
import { getCiudadano } from 'api/padrones';
import { updateEntidadInfo } from 'store/auth';

/**
 * GET Nombres de ordenamiento
 * @param {object} params
 * @returns Promise<object[]>
 */
export const getNombresDeOrdenamiento = async (params = null) => {
  try {
    const response = await API.get('/catalogos/nombre-de-ordenamiento-public/', { params });
    response.data.results = response.data.results.map((e) => ({
      ...e,
      key: e.id,
      tipo: e.tipo_de_ordenamiento?.descripcion?.toUpperCase() || '',
      ambito: e.ambito_de_ordenamiento?.descripcion?.toUpperCase() || '',
      fecha: e.fecha_de_publicacion ? toMoment(e.fecha_de_publicacion)?.format() : '',
    }));
    return response.data;
  } catch (error) {
    _logger(error);
    return { results: [], count: 0 };
  }
};

/**
 * GET Usos de CFDI
 * @returns Promise<object[]>
 */
export const getUsosDeCFDI = async () => {
  try {
    const response = await API.get('catalogos/uso-del-cfdi-public');
    return response.data.map((e) => ({
      label: `${e.uso_del_cfdi} - ${e.descripcion}`,
      value: e.id,
    }));
  } catch (error) {
    _logger(error);
    return [];
  }
};

/**
 * GET Ladas
 * @returns Promise<object[]>
 */
export const getLadas = async (dispatch) => {
  try {
    const response = await API.get('usuarios/lada');
    if (dispatch) {
      dispatch(setLadas(response.data));
    }
    return response.data;
  } catch (error) {
    _logger(error);
    return [];
  }
};

/**
 * GET Tipos de Personas
 * @returns Promise<object[]>
 */
export const getTiposDePersonas = async () => {
  try {
    const response = await API.get('catalogos/tipos-de-personas');
    return response.data;
  } catch (error) {
    _logger(error);
    return [];
  }
};

/**
 * GET Content Types Padrones
 * @returns Promise<object[]>
 */
export const getContentypesPadrones = async (dispatch) => {
  try {
    const response = await API.get('catalogos/content-types-padrones-public');
    if (dispatch) {
      dispatch(setContentTypesPadrones(response.data));
    }
    return response.data;
  } catch (error) {
    _logger(error);
    return [];
  }
};

/**
 * GET Regimenes Capitales
 * @returns Promise<object[]>
 */
export const getRegimenesCapitales = async () => {
  try {
    const response = await API.get('catalogos/regimenes-capitales-public');
    return response.data;
  } catch (error) {
    _logger(error);
    return [];
  }
};

/**
  * GET Configuracion de la Entidad
  * @param {Function} dispatch
  * @returns Promise<object|null>
*/
export const getEntidadConfig = async (dispatch) => {
  try {
    const response = await API.get(`/catalogos/entidad-public/${ID_ENTIDAD}/`);
    if (response.data.configuracion?.ciudadano_publico_en_general) {
      const { ciudadano_publico_en_general: id } = response.data.configuracion;
      const ciudadano = (await getCiudadano(false, { id })).results[0];
      response.data.configuracion.ciudadano_publico_en_general = ciudadano;
    }
    if (typeof dispatch === 'function') {
      dispatch(updateEntidadInfo(response.data));
    }
    return response.data;
  } catch (error) {
    _logger(error);
    return [];
  }
};

/**
 * GET Razones de Rechazo
 * @param {Object} params
 * @returns {Promise<object[]>}
 */
export const getRazonesDeRechazo = async (params = null) => {
  try {
    const response = await API.get('/catalogos/razones-de-rechazo/', { params });
    return response.data;
  } catch (error) {
    _logger(error);
    return [];
  }
};

/**
 * GET Razones de Rechazo
 * @param {Object} params
 * @returns {Promise<object[]>}
 */
export const getRazonesDeRechazoCita = async (params = null) => {
  try {
    const response = await API.get('/recaudacion/razones-de-rechazos-para-citas-public/', { params });
    return response.data;
  } catch (error) {
    _logger(error);
    return [];
  }
};

/**
 * GET Codigo Postal
 * @param {Object} params
 * @returns {Promise<object[]>}
 */
export const getCodigoPostal = async (cp) => {
  try {
    const response = await API.get(`/catalogos/codigos-postales-public/${cp}`);
    return response.data;
  } catch (error) {
    _logger(error);
    return [];
  }
};

export const getVersionesVehiculares = async (params = null) => {
  try {
    const response = await API.get('/catalogos/versiones-vehiculares/', { params });
    return response.data;
  } catch (err) {
    _logger(err);
    return [];
  }
};

export const getColoresVehiculos = async (params = null) => {
  try {
    const response = await API.get('/catalogos/catalogos-de-colores-vehiculares/', {
      params: {
        ...params,
        entidad: ID_ENTIDAD,
      },
    });
    return response.data;
  } catch (err) {
    _logger(err);
    return [];
  }
};

export const getCatalogoDePaises = async (params = null) => {
  try {
    const response = await API.get('/catalogos/catalogos-de-paises/', { params });
    return response.data;
  } catch (err) {
    _logger(err);
    return [];
  }
};

export const getUsosDeMotocicletas = async (params = null) => {
  try {
    const response = await API.get('/catalogos/usos-de-motocicletas/', { params });
    return response.data;
  } catch (err) {
    _logger(err);
    return [];
  }
};

export const getTiposDeCombustibles = async (params = null) => {
  try {
    const response = await API.get('/catalogos/tipos-de-combustibles-vehiculares/', { params });
    return response.data;
  } catch (err) {
    _logger(err);
    return [];
  }
};

export const getDocumentosDeRegularizacion = async (params = null) => {
  try {
    const response = await API.get('/catalogos/clave-de-documento-de-regularizacion/', { params });
    return response.data;
  } catch (err) {
    _logger(err);
    return [];
  }
};

export const getTiposDeEstablecimientos = async () => {
  try {
    const response = await API.get('/empresas/tipos-de-establecimientos');
    return response.data;
  } catch (err) {
    _logger(err);
    return [];
  }
};

export const getEstadosDelPadron = async () => {
  try {
    const response = await API.get('/catalogos/estados-del-padron/');
    return response.data;
  } catch (err) {
    _logger(err);
    return [];
  }
};

export const getObligacionesFiscales = async () => {
  try {
    const response = await API.get('/empresas/obligaciones-fiscales/');
    return response.data;
  } catch (err) {
    _logger(err);
    return [];
  }
};

export const getObligacionesFiscalesDeContribuyentes = async (params = null) => {
  try {
    const response = await API.get('/empresas/obligaciones-fiscales-de-contribuyentes/', { params });
    return formatReceived(response.data);
  } catch (err) {
    _logger(err);
    return [];
  }
};

export const getEstatusDeObligacionesFiscales = async () => {
  try {
    const response = await API.get('empresas/estatus-de-obligaciones-fiscales/');
    return response.data;
  } catch (err) {
    _logger(err);
    return [];
  }
};

export const postConstanciasContribuyente = async (values) => {
  try {
    const response = await API.post('empresas/constancias-contribuyentes/', values);
    return response.data;
  } catch (err) {
    _logger(err);
    return null;
  }
};

export const getMunicipios = async (params = null) => {
  try {
    const response = await API.get('/catalogos/municipios/', { params });
    return response.data;
  } catch (err) {
    _logger(err);
    return null;
  }
};

export const getCodigosPostales = async (params = null, all = true) => {
  try {
    const response = await API.get('/catalogos/codigos-postales/', { params });
    if (all) {
      if (!response.data.next) return response.data.results;
      const page = new URL(response.data.next).searchParams.get('page');
      const colonias = await getCodigosPostales({ ...params, page });
      return response.data.results.concat(colonias);
    }
    return response.data;
  } catch (err) {
    _logger(err);
    return [];
  }
};

export const getConstancias = async (params = null) => {
  try {
    const response = await API.get('/empresas/constancias-contribuyentes/', { params });
    return response.data;
  } catch (err) {
    _logger(err);
    return [];
  }
};

export const getPeriodos = async () => {
  try {
    const response = await API.get('/recaudacion/periodos-public/');
    return response.data.results;
  } catch (err) {
    _logger(err);
    return [];
  }
};

export const getTiposDeDeclaracionesEmpresariales = async () => {
  try {
    const response = await API.get('/empresas/tipos-de-declaraciones-empresariales/');
    return response.data;
  } catch (err) {
    _logger(err);
    return [];
  }
};

export const getTiposDeActividadEmpresarial = async () => {
  try {
    const response = await API.get('/empresas/clases-de-actividades-empresariales-public/');
    return response.data;
  } catch (err) {
    _logger(err);
    return [];
  }
};

export const getTiposDeVialidades = async () => {
  try {
    const response = await API.get('/usuarios/tipo-vialidad/');
    return response.data;
  } catch (err) {
    _logger(err);
    return [];
  }
};

/**
 * GET Catálogos del Mes
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getCatalogoDelMes = async (dispatch) => {
  try {
    const response = await API.get('catalogos/catalogos-del-mes/');
    if (dispatch) {
      dispatch(setMeses(response.data));
    }
    return response.data;
  } catch (err) {
    _logger(err);
    return [];
  }
};

export const getConstanciasContribuyente = async (params) => {
  try {
    const response = await API.get('empresas/constancias-contribuyentes/', { params });
    return response.data;
  } catch (err) {
    _logger(err);
    return [];
  }
};

/**
 * GET Nombres de ordenamiento
 * @param {object} params
 * @returns Promise<object[]>
 */
export const getDiasInhabiles = async (params = null) => {
  try {
    const response = await API.get('/catalogos/dias-inhabil-public/', { params });
    return response?.data || [];
  } catch (error) {
    _logger(error);
    return { results: [], count: 0 };
  }
};

/**
  * GET Caruseles
  * @param {Function} dispatch
*/
export const getTiposDeNoticias = async (dispatch) => {
  try {
    const response = await API.get('tramites/tipos-de-noticias-public');
    const data = response.data.map((t) => ({
      value: t.id,
      label: t.descripcion,
      slug: toSlug(`${t.id}-${t.descripcion}`),
    }));
    if (typeof dispatch === 'function') {
      dispatch(setTiposDeNoticias(data));
    }
    return data;
  } catch (error) {
    _logger(error);
  }
  return [];
};

/**
  * GET Noticias
  * @param {Function} dispatch
*/
export const getNoticias = async (_params, dispatch) => {
  const params = { ..._params, estados_globales: DEV ? undefined : 4 };
  if (!params.publicar_en_portada && !params.page) {
    params.page = 1;
  }
  try {
    const tiposDeNoticias = await getTiposDeNoticias(dispatch);
    const response = await API.get('tramites/noticias-public', { params });
    if (typeof dispatch === 'function') {
      const map = (n) => ({
        ...n,
        autor: n.autor ? ['first_name', 'last_name', 'second_last_name']
          .map((k) => n.autor[k]).filter((e) => e).join(' ') : '',
        tipo_noticia: tiposDeNoticias.find((t) => t.value === n.tipo_noticia)?.label,
        fecha_publicacion: toMoment(n.fecha_publicacion)?.format('LL'),
        key: toSlug(`${n.id} ${n.titulo}`),
        imagenes_de_noticias: n.imagenes_de_noticias || [],
        dependencia: n.dependencia?.descripcion || (n.dependencia === 2 ? 'REGISTRO PÚBLICO VEHICULAR' : ''),
      });

      if (params.publicar_en_portada) {
        response.data = response.data.map(map);
        dispatch(setNoticiasHome(response.data));
        return response.data;
      }
      response.data.params = response.config.params;
      delete response.data.params.estados_globales;
      response.data.results = response.data.results.map(map);
      dispatch(setNoticias(response.data));
      return response.data;
    }
  } catch (error) {
    // _logger(error);
  }
  const _default = params.publicar_en_portada ? [] : { results: [] };
  const setter = (params.publicar_en_portada ? setNoticiasHome : setNoticias);
  if (!params.publicar_en_portada) {
    _default.params = params;
    delete _default.params.estados_globales;
  }
  dispatch(setter(_default));
  return _default;
};

const getImagenesCarrusel = async (apartado_carrusel) => {
  try {
    const response = await API
      .get('recaudacion/imagenes-carrusel-public', { params: { apartado_carrusel } });
    return response.data.map((e) => ({
      ...e,
      base64: e.base64 ? `data:image/${e.extension_del_archivo};base64,${e.base64}` : null,
    }));
  } catch (error) {
    // _logger(error);
  }
  return [];
};

/**
  * GET Caruseles
  * @param {Function} dispatch
*/
export const getCarruseles = async (dispatch) => {
  try {
    const response = await API.get('recaudacion/apartados-carrusel-public');
    const imagenes = await Promise.all(response.data.map((c) => getImagenesCarrusel(c.id)));
    if (typeof dispatch === 'function') {
      dispatch(setCarousels(response.data.map((c, idx) => ({
        ...c,
        imagenes: imagenes[idx].sort((a, b) => a.orden - b.orden),
        vertical: c.vertical ?? true,
      })).sort((a, b) => a.orden - b.orden)));
    }
  } catch (error) {
    // _logger(error);
  }
  return true;
};

/**
 * Busca el último INPC disponible de forma recursiva
 * @param {number} year - Año a consultar
 * @param {number} month - Mes a consultar
 * @returns {Promise<Object>} - Datos del INPC encontrado
 */
const buscarINPC = async (year, month) => {
  try {
    const response = await API.get('/configuracion/inpc-public/', {
      params: { periodo: year, mes: month },
    });

    if (response.data.results.length > 0) {
      return response.data;
    }

    // Si no hay resultados, intentamos con el mes anterior
    if (month > 1) {
      return buscarINPC(year, month - 1);
    }

    // Si estamos en enero, intentamos con el año anterior
    if (year > 2020) { // Año mínimo para buscar INPC
      return buscarINPC(year - 1, 12);
    }

    return { results: [] };
  } catch (error) {
    _logger(error);
    return { results: [] };
  }
};

/**
 * Obtiene el último INPC disponible
 * @param {Function} dispatch - Función dispatch de Redux (opcional)
 * @returns {Promise<Object>} - Datos del INPC encontrado
 */
export const getINPC = async (dispatch) => {
  try {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;

    const inpcData = await buscarINPC(currentYear, currentMonth);

    if (dispatch) {
      dispatch(setINPC(inpcData.results[0]));
    }

    return inpcData;
  } catch (error) {
    _logger(error);
    return { results: [] };
  }
};
